import { render, staticRenderFns } from "./ReferralInstitutiont.vue?vue&type=template&id=28c26a4a&scoped=true"
import script from "./ReferralInstitutiont.vue?vue&type=script&lang=js"
export * from "./ReferralInstitutiont.vue?vue&type=script&lang=js"
import style0 from "./ReferralInstitutiont.vue?vue&type=style&index=0&id=28c26a4a&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c26a4a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28c26a4a')) {
      api.createRecord('28c26a4a', component.options)
    } else {
      api.reload('28c26a4a', component.options)
    }
    module.hot.accept("./ReferralInstitutiont.vue?vue&type=template&id=28c26a4a&scoped=true", function () {
      api.rerender('28c26a4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/screeningConfig/physicalConfig/referralInstitutiont/ReferralInstitutiont.vue"
export default component.exports